import React, { useState } from "react";
import { BottomNavigation, BottomNavigationAction, Paper } from "@mui/material";
import DashboardIcon from "@mui/icons-material/Dashboard";
import AnalyticsIcon from "@mui/icons-material/Analytics";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";

const BottomNav = ({ onClickItem }) => {
  const [selectedItem, setSelectedItem] = useState("dashboard");

  const handleClick = (component) => {
    setSelectedItem(component);
    onClickItem(component);
  };

  return (
    <Paper
      elevation={3}
      sx={{
        position: "fixed",
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 1300,
      }}
    >
      <BottomNavigation
        value={selectedItem}
        onChange={(event, newValue) => handleClick(newValue)}
        showLabels
        sx={{
          backgroundColor: "#f8f9fa",
          "& .Mui-selected": {
            color: "#9c27b0", // Couleur violette pour l'élément sélectionné
          },
        }}
      >
        <BottomNavigationAction
          label="Dashboard"
          value="dashboard"
          icon={<DashboardIcon />}
          sx={{
            "&.Mui-selected": {
              color: "#9c27b0",
            },
          }}
        />
        <BottomNavigationAction
          label="Utilisateurs"
          value="user"
          icon={<AnalyticsIcon />}
          sx={{
            "&.Mui-selected": {
              color: "#9c27b0",
            },
          }}
        />
        <BottomNavigationAction
          label="Nomenclature"
          value="nomenclature"
          icon={<ShoppingCartIcon />}
          sx={{
            "&.Mui-selected": {
              color: "#9c27b0",
            },
          }}
        />
        <BottomNavigationAction
          label="Marketing"
          value="marketing"
          icon={<AccountCircleIcon />}
          sx={{
            "&.Mui-selected": {
              color: "#9c27b0",
            },
          }}
        />
      </BottomNavigation>
    </Paper>
  );
};

export default BottomNav;
